import {terminalSvg as Icon__small__terminalSvg} from '../Icon__small/Icon__small--terminal.js';

export var terminal = {
  name: 'terminal',
  category: 'icon',
  colorable: true,
  svg: Icon__small__terminalSvg,
};
